module.exports = __webpack_public_path__ + "img/avex_coaches_top.a45193f9.jpg";